import { h, Component } from "preact";
import $ from "jquery";
import GlobState from 'globstate'
import Globals from '../globals.js'
import { route } from 'preact-router';

import Swal from 'sweetalert2'

class Template extends Component {
  constructor(props) {
    super(props);
    // console.log('.template', props);
    // let qAnswered = 
    this.state = {
      id: props.id,
      data: props.data,
      qAnswered: 0,
    };
  }
  componentDidMount() { }

  gotoTest = (e) => {
    e.preventDefault();

    let answers = JSON.parse(localStorage.getItem('answers_' + this.state.id));
    if (!answers) {
      route(`/templates/${this.state.id}/`);
      return true;
    }

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success mx-3',
        cancelButton: 'btn btn-danger'
      },
      buttonsStyling: false
    })

    swalWithBootstrapButtons.fire({
      title: 'Продолжить?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Продолжить...',
      cancelButtonText: 'Начать сначала!',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        route(`/templates/${this.state.id}/`);
      } else if (
        result.dismiss === Swal.DismissReason.cancel
      ) {
        localStorage.setItem('answers_' + this.state.id, null);
        localStorage.setItem('exp_' + this.state.id, null);
        route(`/templates/${this.state.id}/`);
      }
    })
  }

  render() {
    let data = this.state.data;
    let qLength = data.questions.length;
    let templateId = this.state.id;
    let myFavs = JSON.parse(localStorage.getItem('favs_' + templateId))
    let answers = JSON.parse(localStorage.getItem('answers_' + templateId));
    let usedExp = JSON.parse(localStorage.getItem('exp_' + templateId));
    let answered = 0;
    let counters = {
      err: 0,
      exp: 0,
    }

    let correctId = '';
    let isCorrect = false;
    Object.keys(data.questions).map((i) => {
      let question = data.questions[i];
      if (answers && answers[question.id]) {
        correctId = question.correctId;
        isCorrect = (correctId == answers[question.id]);
        if (isCorrect) {
          answered++;
        } else {
          counters.err++;
        }
      }
      if (usedExp && usedExp[question.id]) {
        counters.exp++;
      }
    })

    let templateClass = 'marathon_item';
    if (answered == qLength) {
      templateClass += ' border-success';
    } else {
      if (counters.err > 0) {
        templateClass += ' border-danger';
      } else if (counters.exp > 0) {
        templateClass += ' border-warning';
      }

    }
    return (
      <>
        <a href="javascript:void(0)" onClick={this.gotoTest} class={templateClass}>
          <div class="d-flex flex-column me-3">
            <span class="blue_text">Билет {data.title}</span>
            <span class="gray_text font14">{qLength} вопросов</span>
          </div>
          <div class="d-flex flex-column align-items-end">
            {
              (answered == qLength ?
                <i class="demo-icon icon-ok check_icon"></i>
                : (counters.err > 0 ?
                  <span class="red_text font14">{counters.err} ошибок</span>
                  : null)
              )
            }
            {
              (counters.exp > 0 ?
                <span class="text-warning font14">{counters.exp} подсказок</span>
                : null)
            }
          </div>
        </a>
      </>
    );
  }
}

export default GlobState.connect(Template, Globals)